var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "Appx" },
    [
      !_vm.hideNav.includes(_vm.$route.name) ? _c("MainHeader") : _vm._e(),
      _vm._v(" "),
      _c("MobileTopBar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-wrapper" },
        [
          !_vm.hideSideBar.includes(_vm.$route.name) ? _c("SideBar") : _vm._e(),
          _vm._v(" "),
          _c("router-view", { staticClass: "content" }),
          _vm._v(" "),
          _c("MobileBottomBar")
        ],
        1
      ),
      _vm._v(" "),
      _vm.$store.state.modelOpened
        ? _c("div", {
            staticClass: "screen__clone",
            on: {
              click: function($event) {
                _vm.$store.state.modelOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 